import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { Configs } from '../app.config'
import { MzModalComponent } from 'ngx-materialize';
import { DialogDataExampleDialog } from '../popup.component';
import {MatButtonModule} from '@angular/material/button';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


import { isNullOrUndefined } from 'util';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less'],
})
export class HomeComponent implements OnInit {
    @ViewChild('ChooseAppType') ChooseAppType: MzModalComponent
    @ViewChild('ChooseAppVersion') ChooseAppVersion: MzModalComponent
  errorMessage: string;
    userInfo: any;
    AppName: any = [];
    AppTypeIDS: any = [];
    button: boolean=false;
    chosenAppType: number = 0;
    showpage: boolean = false;
    baseURL: any;

    constructor(private appService: AppService, private router: Router, private configs: Configs, private sanitizer: DomSanitizer) {
        this.appService.SetLoadingShow(false);
        this.AppName = [];
        this.AppTypeIDS = [];
        this.baseURL = '';
  }

    ngOnInit() {
      this.baseURL = this.sanitizer.bypassSecurityTrustUrl(this.configs.BaseURL() + "/spmv2");
        this.userInfo = this.appService.GetLoginUserInfo();
        if (!isNullOrUndefined(this.userInfo)) {
            this.showpage = true;
            this.chosenAppType = this.userInfo.AppType;
            if (this.userInfo.UserAccessOptions.length == 1) {
                this.LoadPage(this.userInfo.UserAccessOptions[0].OptionRoute);
            }
            if (this.userInfo.AccessType.length > 1) {
                this.button = true;

            }
            else {
                this.userInfo.AppType = this.userInfo.AccessType[0].AppType;


            }
        } else {
          this.router.navigate(['no-access']);
        }
    }
    
    ngAfterViewInit(): void {
      this.showVersionModalOnce();
    }

    showVersionModalOnce(): void {
      const hasShownModal = sessionStorage.getItem('hasShownVersionModal');
      if (!hasShownModal) {
        this.ChooseAppVersion.openModal();
        sessionStorage.setItem('hasShownVersionModal', 'true');
      }
    }
  
  
 
  LoadPage(url): void {
    if (url != '') {
      this.appService.SetLoadingShow(true);
      //if (url == '/approvals') {
      this.router.navigate([url]);
      //}
    }

  }
    openAppTypeModal() {
      
        this.ChooseAppType.openModal();
             
    }
    closeAppTypeModal() {
        this.userInfo.AppType = this.chosenAppType;
        this.appService.SetLoginUserInfo(this.userInfo);
        this.ChooseAppType.closeModal();
    }

    openAppVersionModal() {
      this.ChooseAppVersion.openModal();
    }
    closeAppVersionModal() {
      this.ChooseAppVersion.closeModal();
    }
  
}
